import React from "react";
import ReactDOM from "react-dom";
import App from "./views/App";
import "./assets/icons/css/fontello.css";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(<App />, document.getElementById("root"));

serviceWorker.unregister();
